const FinancialCalculation = () => import(/* webpackChunkName: "financialCalculation" */ './FinancialCalculation.vue')

const index = {
  path: 'financial/calculation',
  name: 'Financial Calculation',
  component: FinancialCalculation,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
